export default ({ savedItems: { lastItemWithSizeSelectErrorId } }, { id }) =>
  lastItemWithSizeSelectErrorId === id;
